import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FaFacebookF, href: '#', label: 'Facebook' },
    { icon: FaTwitter, href: '#', label: 'Twitter' },
    { icon: FaInstagram, href: '#', label: 'Instagram' },
    { icon: FaLinkedinIn, href: '#', label: 'LinkedIn' }
  ];

  return (
    <footer className="bg-gray-900 text-white relative">
      {/* Top Wave Decoration */}
      <div className="absolute top-0 left-0 right-0 h-8 bg-primary-600 opacity-10 transform -translate-y-1/2 rounded-b-[100%]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Logo className="h-12 w-auto" color="white" />
            <p className="text-gray-400 leading-relaxed">
              Your trusted partner in home improvement and security solutions. Providing premium impact windows and doors since 2007.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-primary-600 hover:text-white transition duration-300"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6 flex items-center">
              Quick Links
            </h3>
            <ul className="space-y-4">
              <li>
                <Link to="/products" className="text-gray-400 hover:text-primary-500 transition duration-300 flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-600 rounded-full mr-2" />
                  Products
                </Link>
              </li>
              <li>
                <Link to="/advantages" className="text-gray-400 hover:text-primary-500 transition duration-300 flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-600 rounded-full mr-2" />
                  Why Choose Us
                </Link>
              </li>
              <li>
                <Link to="/financing" className="text-gray-400 hover:text-primary-500 transition duration-300 flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-600 rounded-full mr-2" />
                  Financing Options
                </Link>
              </li>
              <li>
                <Link to="/promotions" className="text-gray-400 hover:text-primary-500 transition duration-300 flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-600 rounded-full mr-2" />
                  Special Offers
                </Link>
              </li>
              <li>
                <Link to="/get-estimate" className="text-gray-400 hover:text-primary-500 transition duration-300 flex items-center">
                  <span className="w-1.5 h-1.5 bg-primary-600 rounded-full mr-2" />
                  Get Free Estimate
                </Link>
              </li>
            </ul>
          </div>

         {/* Contact Info */}
<div>
  <h3 className="text-white text-lg font-semibold mb-6">
    Contact Us
  </h3>
  <ul className="space-y-4">
    <li className="flex items-start text-gray-400">
      <FaMapMarkerAlt className="w-5 h-5 text-primary-600 mt-1 mr-3 flex-shrink-0" />
      <span>
        8221 DONALDSON DR<br />
        Tampa, FL 33615
      </span>
    </li>
    <li className="flex items-center text-gray-400">
      <FaPhone className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" />
      <a href="tel:+17542503987" className="hover:text-primary-500 transition duration-300">
        (754) 250-3987
      </a>
    </li>
    <li className="flex items-center text-gray-400">
      <FaEnvelope className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" />
      <a href="mailto:info@ernestowindows.com" className="hover:text-primary-500 transition duration-300">
        info@ernestowindows.com
      </a>
    </li>
    <li className="flex items-center text-gray-400">
      <FaEnvelope className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" />
      <a href="mailto:admin@ernestowindows.com" className="hover:text-primary-500 transition duration-300">
        admin@ernestowindows.com
      </a>
    </li>
  </ul>
</div>

          {/* Business Hours */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-6">
              Business Hours
            </h3>
            <ul className="space-y-4">
              <li className="flex items-center text-gray-400">
                <FaClock className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" />
                <span>
                  Monday - Friday<br />
                  8:00 AM - 6:00 PM
                </span>
              </li>
              <li className="flex items-center text-gray-400">
                <FaClock className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" />
                <span>
                  Saturday<br />
                  9:00 AM - 4:00 PM
                </span>
              </li>
              <li className="flex items-center text-gray-400">
                <FaClock className="w-5 h-5 text-primary-600 mr-3 flex-shrink-0" />
                <span>
                  Sunday<br />
                  Closed
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Ernesto Windows & Doors LLC. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-primary-500 text-sm transition duration-300">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-primary-500 text-sm transition duration-300">
                Terms of Service
              </Link>
              <Link to="/sitemap" className="text-gray-400 hover:text-primary-500 text-sm transition duration-300">
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 